export default __webpack_public_path__ + "static/media/show_nearby_hotels_result.55b290f5.png";